const integrations = {
	smartcredit_conversion: 'smartcredit_conversion',
	smartcredit_lead: 'smartcredit_lead',
	pixel: 'pixel',
	script: 'script',
	online_payments: 'online_payments'
};

const locale = {
	ru: integrations,
	en: {
		smartcredit_conversion: 'SmartCredit conversion',
		smartcredit_lead: 'SmartCredit lead',
		pixel: 'Pixel',
		script: 'Script',
		online_payments: 'Online Payments'
	},
	de: integrations,
	uk: integrations,
	vi: integrations,
	th: integrations
};

const SMARTCREDIT = 'smartcredit';
const PIXEL = 'pixel';
const SCRIPT = 'script';
const ONLINE_PAYMENTS = 'online_payments';

const idProviders = {
	[integrations.smartcredit_conversion]: SMARTCREDIT,
	[integrations.smartcredit_lead]: SMARTCREDIT,
	[integrations.pixel]: PIXEL,
	[integrations.script]: SCRIPT,
	[integrations.online_payments]: ONLINE_PAYMENTS
};

const referenceNames = {
	[integrations.smartcredit_conversion]: 'rocketprofit',
	[integrations.smartcredit_lead]: 'rocketprofit2'
};

module.exports = {
	enum: integrations,
	locale: locale,
	PIXEL,
	idProviders,
	SMARTCREDIT,
	ONLINE_PAYMENTS,
	referenceNames,
	SCRIPT
};



// WEBPACK FOOTER //
// ./enums/offer-external-integrations.js